import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormControl, Input } from 'components';

const NumberFieldPreview = ({
    defaultValue,
    isDisabled,
    onChange,
    ...props
}) => {
    const [value, setValue] = useState(defaultValue);

    const handleChange = event => {
        setValue(event.target.value);
        onChange(event.target.value);
    };

    return (
        <FormControl fullWidth>
            <Input
                value={value}
                type='number'
                onChange={handleChange}
                disabled={isDisabled}
                { ...props }
            />
        </FormControl>
    );
};

NumberFieldPreview.propTypes = {
    isDisabled: PropTypes.bool,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    onChange: PropTypes.func
};

NumberFieldPreview.defaultProps = {
    isDisabled: false,
    defaultValue: '',
    onChange: () => {}
};

export default NumberFieldPreview;
